import React,{useState,useEffect} from 'react';
import {getMasterCardUrl, sendMastercardSessionId} from '../../actions/MasterCardAction';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {Base64,encode} from 'base-64'
import { salesforceSendFormNumber } from '../../actions/StudentAction';
const MasterCard = (props) => {
    const [loading,setLoading] = useState(false)
    const navigate = useNavigate()
    const [successIndicator,setSuccessIndicator] = useState()
    const detail=props.detail
    const feeDetail=props.feeDetail !==undefined && props.feeDetail
    const payType=props.payType
    const {installment_amount,installment_amount_local,installments_id,net_payable_amount,scholarship_amount,scholarship_percentage,lumpsum_amount,lumpsum_amount_local}=feeDetail
    const{name,email,id,address1,address2,city,city_id, other_city,country,zip_code,mobile_no}=detail
    const fee_type = payType.value
    const paymentConfig = props.paymentConfig !==undefined && props.paymentConfig

    // const { installment_amount, lumpsum_amount } = feeDetail
    const amount = payType !== undefined && payType.value == 1 ? installment_amount_local? installment_amount_local:installment_amount : lumpsum_amount_local?lumpsum_amount_local:lumpsum_amount

    const masterCardHandle = () => {
        setLoading(true)
        const data = {
            fno: detail?.form_num,
	        amount:parseFloat(amount).toFixed(2),
            gateway_id: paymentConfig.id,
	        name: detail?.name,
	        cancel_url:`${process.env.REACT_APP_WEB_URL}/dashboard`,
	        success_url:`${process.env.REACT_APP_WEB_URL}/payment-successfull/${detail.id}/${payType?.value}/?payment=` 
 
        }
        
        getMasterCardUrl(data).then((res) => {
            setLoading(true)
            if(res.status){
                setLoading(false)
                salesforceSendFormNumber({form_num:detail?.form_num,status:'payment_initiated'})
                window.location.href=`https://admin.allenoverseas.com/2023-2024/getmastercardSessionid/${res.session_id}`
            }
        })




    }
    
  
    // let sessionId = Base64.encode(sessionUrl)

    return (
        <div>
      
        {loading ? <button type="submit" disabled className="banktransfer_btn">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Processing ...</button> : 
                <>
           <button onClick={masterCardHandle} className='banktransfer_btn'>Credit/Debit Card</button>
        </>


        }
        </div>
    )
}

export default MasterCard

